module.exports = __webpack_public_path__ + "static/img/surface12.66b59b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface12.png
// module id = wT+i
// module chunks = 2